import { Host, h } from '@stencil/core';
// import mockData from './_mock/aiba-progress-screen.json';
export class AibaProgressScreen {
  constructor() {
    this.onCloseClick = e => {
      var _a;
      this.displayProgress = false;
      this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.closeProgressScreenModal(e));
      this.closeProgressModel.emit({
        closed: true,
      });
    };
    this.data = undefined;
    this.displayProgress = true;
    this.handlers = undefined;
    this.handleOnCloseClick = undefined;
    this.attributeTitle = undefined;
    this.title = undefined;
    this.isTargetAchieved = undefined;
    this.attributeTarget = '';
    this.attributeContent = '';
  }
  skinAttributeClickedEventHandler(event) {
    this.attributeTitle = event.detail['attributeTitle'];
    this.attributeTarget = event.detail['attributeTarget'][0];
  }
  updateEventContentHandler(event) {
    var _a;
    this.isTargetAchieved = event.detail['targetAchieved'];
    this.attributeContent = this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.attributeContent(event, this.data, this.isTargetAchieved, this.attributeTitle, this.attributeTarget));
  }
  render() {
    var _a;
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    return (h(Host, { class: `${this.displayProgress === false ? 'hide' : ''}` }, this.displayProgress && (h("div", { class: "progress-screen-wrapper" }, this.data &&
      ((_a = this.data) === null || _a === void 0 ? void 0 : _a.map((element) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (element.name === 'aiba-close-button') {
          return (h("aiba-close-button", Object.assign({}, element['data'], { handleClick: e => this.onCloseClick(e), icon: ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.icon) ? (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.icon : (_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.icon, text: ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.text) ? (_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.text : (_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.text })));
        }
        if (element && element['name'] === 'progress-screen-header') {
          return (h("div", { class: "progress-screen-header" }, (_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.elements.map(item => {
            if (item.name === 'aiba-label')
              return h("aiba-label", Object.assign({}, item['data']));
          })));
        }
        if (element && element['name'] === 'progress-screen-footer') {
          return (h("div", { class: "progress-screen-footer" }, (_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.elements.map(item => {
            if (this.attributeTitle && item['data'] && item['data']['_id'] && item['data']['_id'] === 'attributeTitle') {
              if (item.name === 'aiba-label')
                return h("aiba-label", Object.assign({}, item['data'], { text: this.attributeTitle }));
            }
            else {
              if (item.name === 'aiba-label')
                return h("aiba-label", Object.assign({}, item['data']));
            }
            if (this.attributeContent && item['data'] && item['data']['_id'] && item['data']['_id'] === 'attributeText') {
              return h("aiba-label", Object.assign({}, item['data'], { text: this.attributeContent }));
            }
          })));
        }
        if (element && element['name'] === 'aiba-chart-container') {
          return h("aiba-chart-list", Object.assign({}, element, { handlers: this.handlers }));
        }
      }))))));
  }
  static get is() { return "aiba-progress-screen"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-progress-screen.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-progress-screen.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "handleOnCloseClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-on-close-click",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "displayProgress": {},
      "attributeTitle": {},
      "title": {},
      "isTargetAchieved": {},
      "attributeTarget": {},
      "attributeContent": {}
    };
  }
  static get events() {
    return [{
        "method": "closeProgressModel",
        "name": "closeProgressModel",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get listeners() {
    return [{
        "name": "skinAttributeClicked",
        "method": "skinAttributeClickedEventHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "updateEventContent",
        "method": "updateEventContentHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-progress-screen.js.map
